module.exports = __webpack_public_path__ + "img/bubble.27530090.svg";